import React, { useEffect, useRef } from "react";
import { Tooltip, Collapse } from "antd";
import { useParams } from "react-router-dom";
import './antSidebar.css';
import { useCanvas } from "../../context/canvasContext";
import { boardServices } from "../../api";
import { useDocument } from "../../context/documentInfoContex";

const { Panel } = Collapse;

const ShapesModal = ({ isShapeModalVisible, setIsShapeModalVisible, shapes, triggerButtonRef }) => {
  const isMobile = window.innerWidth < 768;
  const { id: roomId } = useParams();
  const modalRef = useRef(null);

  const {
    canvasRef,
    createCircle, createRectangle, createTriangle, createEllipse, createSquare, createCylinder,
    createRightAngleTriangle, createDiamond, createRightArrow, createPentagon, createHexagon,
    createStar, createHeptagon, createOctagon, createTrapezoid, createParallelogram,
    createHeart, createCross, createChevron, createSemicircle, createPentagram, createCrescent
  } = useCanvas();

  const { setSavingData, isTemplateDocument } = useDocument();


  const shapeCreators = {
    circle: createCircle,
    rectangle: createRectangle,
    ellipse: createEllipse,
    square: createSquare,
    triangle: createTriangle,
    cylinder: createCylinder,
    "right-angle-triangle": createRightAngleTriangle,
    diamond: createDiamond,
    arrow: createRightArrow,
    pentagon: createPentagon,
    hexagon: createHexagon,
    star: createStar,
    heptagon: createHeptagon,
    octagon: createOctagon,
    trapezoid: createTrapezoid,
    parallelogram: createParallelogram,
    heart: createHeart,
    cross: createCross,
    chevron: createChevron,
    semicircle: createSemicircle,
    pentagram: createPentagram,
    crescent: createCrescent
  };

  const createShape = async (shapeName) => {
    const updatedShapeName = shapeName.trim().toLowerCase();
    const creator = shapeCreators[updatedShapeName];

    if (creator) {
      // create the shape
      creator(roomId);

      // save canvas after adding shape
      if (canvasRef?.current) {
        try {
          const canvasData = canvasRef.current.toJSON(["selectable", "id", "type"]);
          await boardServices.updateBoardData(roomId, canvasData, setSavingData, isTemplateDocument);
        } catch (error) {
          console.error("Failed to update board after adding shape:", error);
        }
      } else {
        console.warn("canvasRef is not ready");
      }
    } else {
      console.warn("Unrecognized shape:", shapeName, updatedShapeName, creator);
    }
  };

  useEffect(() => {
    if (!isShapeModalVisible || !triggerButtonRef?.current || !modalRef?.current) return;

    const buttonRect = triggerButtonRef.current.getBoundingClientRect();
    const parentRect = triggerButtonRef.current.offsetParent?.getBoundingClientRect();
    const modal = modalRef.current;

    const offsetX = 10;
    const offsetY = isMobile ? 40 : 0;

    const newLeft = buttonRect.left - parentRect.left + buttonRect.width + offsetX;
    const newTop = isMobile
      ? buttonRect.top - parentRect.top + buttonRect.height + offsetY
      : buttonRect.top - parentRect.top;

    const modalWidth = isMobile ? 155 : 168;
    const maxLeft = window.innerWidth - modalWidth - 10;

    Object.assign(modal.style, {
      position: "absolute",
      left: `${Math.min(newLeft, maxLeft) + 40}px`,
      top: `${newTop}px`,
      zIndex: 10
    });
  }, [isShapeModalVisible, triggerButtonRef, isMobile]);

  if (!isShapeModalVisible) return null;

  return (
    <div
      ref={modalRef}
      className="shapes-collapse"
      style={{
        width: isMobile ? 155 : 180,
        boxShadow: "0 3px 8px rgba(101, 92, 92, 0.5)",
        borderRadius: 5
      }}
    >
      <Collapse
        bordered
        expandIconPosition="right"
        defaultActiveKey={['1']}
        onChange={(key) => key.length === 0 && setIsShapeModalVisible(false)}
      >
        <Panel header="Shapes" key="1" style={{ fontSize: isMobile ? 11 : 13 }}>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              cursor: 'pointer'
            }}
          >
            {shapes.map((shape) => (
              <Tooltip key={shape.id} title={shape.name}>
                <div
                  style={{
                    margin:
                      shape.name === 'triangle' ? '4px 12px' :
                        shape.name === 'rectangle' ? '5px 10px' :
                          '10px'
                  }}
                  onClick={() => createShape(shape.name)}
                >
                  {shape.image}
                </div>
              </Tooltip>
            ))}
          </div>
        </Panel>
      </Collapse>
    </div>
  );
};

export default ShapesModal;